export default __webpack_public_path__ + "bd696894e86696d3d3f58ad4f1da33de.png";